function initialiseLuma(root) {
const controller = new AbortController(), signal = controller.signal;
const q = s => root.querySelector(s);
const all = s => [...root.querySelectorAll(s)];
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const order = ['dawn', 'day', 'dusk'];
const config = JSON.parse(q('[data-luma-config]').textContent);
const flavours = config.flavours;
const t = (key, values = {}) => Object.entries(values).reduce((s,[k,v]) => s.replaceAll(`{${k}}`,v),config.strings[key] || key);
const released = Object.fromEntries(order.map(k => [k,flavours[k].released]));
const seenKey = 'luma:reveals:v1';
let seen = [];
try {const saved = JSON.parse(sessionStorage.getItem(seenKey) || '[]'); if (Array.isArray(saved)) seen = saved;} catch {}
const states = Object.fromEntries(order.map(k => [k, {index:0, revealed:!!released[k] && seen.includes(k)}]));
function rememberReveal(key) {
  states[key].revealed = true;
  try {sessionStorage.setItem(seenKey,JSON.stringify(order.filter(k => states[k].revealed)));} catch {}
}
let active = 'dawn', requested = 'dawn', version = 0, readyKey = '', loading = false;
let changeTimer, revealTimer, scrollFrame, warmTimer, companionVersion = 0;
const warmed = new Set(), pendingImages = new Set();

function imageFor(key, index, clear, deferred = false) {
  const im = document.createElement('img'), f = flavours[key];
  const source = clear ? [f.pack,f.bite,f.lifestyle][index] : null;
  im.className = clear ? 'sharp' : 'soft';
  im.sizes = '(max-width:650px) calc(100vw - 24px), (min-width:1600px) 760px, 47vw';
  if (deferred) {
    im.src = source.preview;
    im.dataset.src = source.src;
    if (source.srcset) im.dataset.srcset = source.srcset;
  } else {
    if (source?.srcset) im.srcset = source.srcset;
    im.src = source?.src || f.locked;
  }
  im.alt = clear ? f.alts[index] : t('under_wraps_alt',{name:f.name});
  im.width = source?.width || 1200; im.height = source?.height || 1800;
  im.draggable = false; im.decoding = 'async'; return im;
}
function overlayOpacity(clear, animate = false) {
  all('.gallery .soft').forEach(im => {
    im.style.transition = animate && !reduced.matches ? 'opacity 900ms cubic-bezier(.22,1,.36,1)' : 'none';
    im.style.opacity = clear ? '0' : '1';
    im.alt = clear ? '' : t('under_wraps_alt',{name:flavours[active].name});
  });
}
function supportingImage(key,index) {
  const source = flavours[key].support[index], im = document.createElement('img');
  im.className = 'sharp'; im.alt = source.alt; im.decoding = 'async'; im.draggable = false;
  im.width = 800; im.height = 1000;
  im.sizes = '(max-width:650px) 40vw, (min-width:1600px) 760px, 47vw';
  im.srcset = source.srcset; im.src = source.src; return im;
}
async function companion() {
  const ticket = ++companionVersion;
  const im = supportingImage(active,states[active].index);
  try {await decode(im);} catch {return;}
  if (ticket !== companionVersion || !root.isConnected) return;
  const previous = q('#bite-image');
  previous.removeAttribute('id'); previous.setAttribute('aria-hidden','true'); im.id = 'bite-image'; previous.after(im);
  if (reduced.matches) {previous.remove(); return;}
  im.animate([{opacity:0},{opacity:1}],{duration:220,easing:'ease-out'}).finished.finally(()=>previous.remove());
}
function warmMedia(key,token) {
  if (token !== version || key !== active || warmed.has(key)) return;
  warmed.add(key);
  const images = [supportingImage(key,0),supportingImage(key,1),supportingImage(key,2),imageFor(key,1,true)];
  images.forEach(im=>{pendingImages.add(im);decode(im).catch(()=>{}).finally(()=>pendingImages.delete(im));});
}

function filmPoster(key) {
  const im = document.createElement('img'); im.className = 'sharp';
  im.src = flavours[key].film?.poster || flavours[key].filmLocked; im.alt = `${flavours[key].name} packaging film, paused`;
  im.width = 640; im.height = 960; return im;
}
function syncFilm() {
  const video = q('#unwrap-video'), button = q('#film-toggle');
  if (!video || !button) return;
  const playing = !video.paused && !video.ended;
  button.classList.toggle('is-playing',playing);
  button.classList.toggle('has-played',video.currentTime > 0 || playing);
  button.setAttribute('aria-pressed',String(playing));
  button.setAttribute('aria-label',`${playing ? t('pause') : t('play')} ${flavours[active].name} unwrapping film`);
  
  button.querySelector('.film-label').textContent = playing ? t('pause') : video.currentTime > 0 ? t('keep_watching') : t('watch');
  button.querySelector('.pause-hint').hidden = !playing;
}
function pauseFilm() {q('#unwrap-video')?.pause();}
document.addEventListener('visibilitychange',() => {if (document.hidden) pauseFilm();},{signal});
function updateGalleryInfo() {
  const st = states[active], f = flavours[active];
  const visible = st.index === 1 || (released[active] && st.revealed);
  document.body.dataset.frame = String(st.index);
  if (st.index === 1) {
    const bite = q('#gallery').children[1].querySelector('img');
    if (bite.dataset.src) {
      if (bite.dataset.srcset) bite.srcset = bite.dataset.srcset;
      bite.src = bite.dataset.src;
      delete bite.dataset.src; delete bite.dataset.srcset;
    }
  }
  [...q('#gallery').children].forEach((slide,index) => {
    slide.inert = index !== st.index;
    slide.setAttribute('aria-hidden',String(index !== st.index));
    slide.querySelectorAll('.sharp').forEach(im => im.setAttribute('aria-hidden',String(index !== 1 && !st.revealed)));
  });
  all('[data-slide]').forEach((b,i) => i === st.index ? b.setAttribute('aria-current','true') : b.removeAttribute('aria-current'));
  q('#previous').disabled = st.index === 0; q('#next').disabled = st.index === 2;
  q('#frame-label').textContent = `${f.name} / 0${st.index+1}`;
  q('#gallery-caption').textContent = [t('caption_pack'),t('caption_bite'),t('caption_film')][st.index];
  q('#gallery-status').textContent = `${f.name}, ${[t('product_photo'),t('bite_photo'),t('unwrap_film')][st.index]}, ${st.index+1} of 3. ${visible ? t('on_view_sentence') : released[active] ? t('ready_sentence') : t('locked_sentence')}`;
  q('#reveal-veil').hidden = visible;
  q('#reveal-veil').classList.remove('is-leaving');
  q('#reveal-kicker').textContent = released[active] ? t('closer') : t('packaging_next');
  q('#locked-title').hidden = !!released[active]; q('#locked-invite').hidden = !!released[active];
  q('#reveal').hidden = !released[active];
  q('#reveal').disabled = loading;
  q('#reveal').textContent = loading ? t('loading') : readyKey === active ? t('reveal',{name:f.name}) : t('retry');
  if (!loading && readyKey === active) {const arrow=document.createElement('span');arrow.textContent='↗';arrow.setAttribute('aria-hidden','true');q('#reveal').append(arrow);}
  q('#watch').hidden = !flavours[active].film?.sources?.length || !released[active] || !st.revealed || readyKey !== active || st.index !== 0;
  q('#film-toggle').hidden = !flavours[active].film?.sources?.length || !released[active] || !st.revealed;
  q('#film-toggle').tabIndex = st.index === 2 && flavours[active].film?.sources?.length && released[active] && st.revealed ? 0 : -1;
  q('#cover-print').src = flavours[active].coverPrint;
}
async function decode(im) {
  try {await im.decode();}
  catch (error) {
    if (im.complete && im.naturalWidth) return;
    if (im.complete) throw error;
    await new Promise((resolve,reject) => {im.addEventListener('load',resolve,{once:true}); im.addEventListener('error',reject,{once:true});});
  }
}
async function loadSharp(key, token) {
  if (!released[key]) return;
  loading = true; updateGalleryInfo();
  const images = [0,2].map(i => {const im = i === 2 ? filmPoster(key) : imageFor(key,i,true); q('#gallery').children[i].prepend(im); return im;});
  try {
    await Promise.all(images.map(decode));
    if (token !== version || key !== active) return;
    readyKey = key; loading = false;
    overlayOpacity(states[key].revealed); updateGalleryInfo();
  } catch {
    if (token !== version || key !== active) return;
    images.forEach(im => im.remove());
    readyKey = ''; loading = false; states[key].revealed = false;
    updateGalleryInfo();
    q('#gallery-status').textContent = t('image_error');
  }
}
function buildFilm(slide, key) {
  const video = document.createElement('video');
  video.id = 'unwrap-video'; video.loop = true; video.muted = true; video.playsInline = true;
  video.preload = 'none'; video.setAttribute('aria-label',key.toUpperCase()+' unwrapping film');
  video.hidden = true;
  const toggle = document.createElement('button'); toggle.id = 'film-toggle'; toggle.type = 'button';
  toggle.hidden = !flavours[key].film?.sources?.length || !released[key] || !states[key].revealed; toggle.setAttribute('aria-label',`Play ${key.toUpperCase()} unwrapping film`); toggle.setAttribute('aria-pressed','false');
  toggle.innerHTML = `<span class="play-disc" aria-hidden="true"><svg class="film-mark" viewBox="0 0 80 92"><path class="play-shape" d="M19 9 C20 31 18 59 17 82 C34 73 56 59 68 46 C53 32 34 19 19 9Z"/><g class="pause-shape"><path d="M29 20 Q28 46 29 72"/><path d="M52 20 Q53 46 52 72"/></g></svg></span><span class="film-label">Watch it unwrap</span><span class="pause-hint" hidden aria-hidden="true">Ⅱ Pause film</span>`;
  const status = document.createElement('p'); status.id = 'film-status'; status.setAttribute('role','status');
  slide.append(video,toggle,status);
  toggle.addEventListener('click',() => {
    if (!released[active] || !flavours[key].film?.sources?.length) return;
    if (!video.paused) {video.pause(); return;}
    if (!video.getAttribute('src') || video.error) {
      const source = flavours[key].film.sources.find(s => s.mime_type === 'video/mp4' && typeof s.url === 'string' && s.url.trim());
      if (!source) {status.textContent = t('film_error'); return;}
      video.poster = flavours[key].film.poster; video.src = source.url;
      video.hidden = false; video.load();
    }
    status.textContent = '';
    rememberReveal(active); overlayOpacity(true); updateGalleryInfo();
    video.play().catch(() => {if (video.isConnected) {status.textContent = t('film_retry'); syncFilm();}});
  });
  video.addEventListener('play',syncFilm); video.addEventListener('pause',syncFilm);
  video.addEventListener('error',() => {if (video.isConnected) status.textContent = t('film_error');});
}
function render(key) {
  pauseFilm(); active = key; readyKey = ''; loading = false;
  clearTimeout(revealTimer);
  const f = flavours[key], s = states[key];
  document.body.dataset.flavour = key;
  document.body.dataset.released = String(!!released[key]);
  const gallery = q('#gallery');
  gallery.setAttribute('aria-label', f.name + ' gallery');
  gallery.replaceChildren(...[0,1,2].map(i => {
    const slide = document.createElement('figure');
    slide.className = 'slide'; slide.setAttribute('role','group');
    slide.setAttribute('aria-roledescription','slide'); slide.setAttribute('aria-label', `${i+1} of 3`);
    const im = imageFor(key,i,i === 1,i === 1 && s.index !== 1);
    if (i === 2) {im.src = flavours[key].filmLocked; im.alt = t('film_locked');}
    slide.append(im); if (i === 2) buildFilm(slide,key); return slide;
  }));
  gallery.scrollTo({left:s.index * gallery.clientWidth, behavior:'instant'});
  companion();
  clearTimeout(warmTimer); const warmToken = version; warmTimer = setTimeout(()=>warmMedia(key,warmToken),450);
  q('#ingredients').textContent = `${f.cacao} CACAO · ${f.name}`;
  q('#taste-title').textContent = f.title; q('#taste-copy').textContent = f.copy;
  q('#mushroom-image').src = flavours[key].mushroomImage;
  q('#mushroom-image').alt = f.mushroom + ' mushroom';
  q('#mushroom-name').textContent = f.mushroom + ' extract';
  q('#nutrient').textContent = 'With ' + f.nutrient;
  updateGalleryInfo();
  if (released[key]) loadSharp(key,version);
}
function select(key, animate) {
  requested = key; version++; clearTimeout(changeTimer); clearTimeout(revealTimer); pauseFilm();
  const moving = animate && !reduced.matches;
  document.body.classList.toggle('instant', !moving);
  all('[data-choice]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.choice === key)));
  q('.choice-marker').style.transform = `translateX(${order.indexOf(key)*100}%)`;
  document.body.dataset.flavour = key;
  if (!moving) {q('#composition').classList.remove('changing'); render(key); return;}
  q('#composition').classList.add('changing');
  changeTimer = setTimeout(() => {
    if (requested !== key) return;
    render(key); requestAnimationFrame(() => q('#composition').classList.remove('changing'));
  },110);
}
all('[data-choice]').forEach(b => {
  if(b.querySelector('small'))b.querySelector('small').textContent = flavours[b.dataset.choice].mushroom;
  b.addEventListener('click',e => {if (requested !== b.dataset.choice) select(b.dataset.choice,e.detail > 0);});
});
function moveTo(index, animate = true) {
  index = Math.max(0,Math.min(2,index));
  pauseFilm();
  q('#gallery').scrollTo({left:index*q('#gallery').clientWidth, behavior:animate && !reduced.matches ? 'smooth' : 'instant'});
}
all('[data-slide]').forEach(b => b.addEventListener('click',e => moveTo(Number(b.dataset.slide),e.detail > 0)));
q('#previous').addEventListener('click',e => moveTo(states[active].index-1,e.detail > 0));
q('#next').addEventListener('click',e => moveTo(states[active].index+1,e.detail > 0));
q('#gallery').addEventListener('keydown',e => {
  if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); moveTo(states[active].index+(e.key === 'ArrowRight' ? 1 : -1),false);}
});
q('#gallery').addEventListener('scroll',() => {
  cancelAnimationFrame(scrollFrame);
  scrollFrame = requestAnimationFrame(() => {
    const g = q('#gallery'), index = Math.max(0,Math.min(2,Math.round(g.scrollLeft/g.clientWidth)));
    if (index !== states[active].index) {states[active].index = index; pauseFilm(); companion(); updateGalleryInfo();}
  });
},{passive:true});
let mouseDrag = null, suppressDragClickUntil = 0;
q('#gallery').addEventListener('pointerdown',e => {
  if (e.pointerType !== 'mouse' || e.button !== 0) return;
  mouseDrag = {id:e.pointerId,x:e.clientX,start:q('#gallery').scrollLeft,moved:false};
});
q('#gallery').addEventListener('pointermove',e => {
  if (!mouseDrag || e.pointerId !== mouseDrag.id) return;
  const delta = e.clientX - mouseDrag.x;
  if (!mouseDrag.moved && Math.abs(delta) < 7) return;
  if (!mouseDrag.moved) {mouseDrag.moved = true; pauseFilm(); q('#gallery').setPointerCapture(e.pointerId); q('#gallery').classList.add('dragging');}
  q('#gallery').scrollLeft = mouseDrag.start - delta;
});
function finishMouseDrag(e) {
  if (!mouseDrag || e.pointerId !== mouseDrag.id) return;
  const moved = mouseDrag.moved; mouseDrag = null;
  if (q('#gallery').hasPointerCapture(e.pointerId)) q('#gallery').releasePointerCapture(e.pointerId);
  q('#gallery').classList.remove('dragging');
  if (moved) {suppressDragClickUntil = performance.now() + 250; const g = q('#gallery'); moveTo(Math.round(g.scrollLeft/g.clientWidth));}
}
q('#gallery').addEventListener('pointerup',finishMouseDrag);
q('#gallery').addEventListener('pointercancel',finishMouseDrag);
q('#gallery').addEventListener('pointerleave',e => {if (mouseDrag && !mouseDrag.moved) mouseDrag = null;});
q('#gallery').addEventListener('click',e => {
  if (e.detail > 0 && performance.now() < suppressDragClickUntil) {e.preventDefault(); e.stopImmediatePropagation();}
},true);
const sizeObserver = new ResizeObserver(() => {
  const g=q('#gallery'); g.scrollTo({left:states[active].index*g.clientWidth,behavior:'instant'});
}); sizeObserver.observe(q('#gallery'));
q('#reveal').addEventListener('click',e => {
  if (!released[active] || loading) return;
  if (readyKey !== active) {loadSharp(active,version); return;}
  const animate = e.detail > 0 && !reduced.matches, token = version;
  document.body.classList.toggle('instant',!animate);
  rememberReveal(active); overlayOpacity(true,animate);
  q('#reveal-veil').classList.add('is-leaving'); q('#reveal').textContent = t('revealing');
  const finish = () => {
    if (token !== version) return;
    const restore = document.activeElement === q('#reveal');
    updateGalleryInfo(); if (restore) q('#gallery').focus({preventScroll:true});
  };
  if (animate) revealTimer = setTimeout(finish,900); else finish();
});
q('#watch').addEventListener('click',e => {
  if (!released[active] || !flavours[key].film?.sources?.length) return;
  moveTo(2,false); states[active].index = 2; companion(); updateGalleryInfo();
  q('#film-toggle').focus({preventScroll:true}); q('#film-toggle').click();
});
const visibilityObserver = new IntersectionObserver(entries => {if (!entries[0].isIntersecting) pauseFilm();},{threshold:.15}); visibilityObserver.observe(q('#gallery'));
const printSequence = [
  {key:'day',name:'Shiitake'}, {key:'dusk',name:'Reishi'}, {key:'dawn',name:"Lion's Mane"}
];
let printIndex = 0, printAnimation;
q('#spore-turn').addEventListener('click',e => {
  printIndex = (printIndex + 1) % printSequence.length;
  const current = printSequence[printIndex], next = printSequence[(printIndex + 1) % printSequence.length];
  q('#letter-print').src = flavours[current.key].print;
  q('#spore-turn').setAttribute('aria-label',`${current.name} print. Show ${next.name} print`);
  q('#spore-status').textContent = `${current.name} spore print`;
  printAnimation?.cancel();
  if (!reduced.matches && e.detail !== 0) {
    printAnimation = q('#letter-print').animate([
      {transform:'rotate(-20deg) scale(.78)',opacity:.35},
      {transform:'rotate(-5deg) scale(1.03)',opacity:1,offset:.75},
      {transform:'rotate(-8deg) scale(1)',opacity:1}
    ],{duration:360,easing:'cubic-bezier(.22,1,.36,1)'});
  }
});
reduced.addEventListener('change',() => printAnimation?.cancel(),{signal});

function fieldError(input, id, message) {
  const error = q(id); error.textContent = message; error.hidden = !message;
  if (message) input.setAttribute('aria-invalid','true'); else input.removeAttribute('aria-invalid');
}
q('#email')?.addEventListener('input',() => fieldError(q('#email'),'#email-error',''));
q('#consent')?.addEventListener('change',() => fieldError(q('#consent'),'#consent-error',''));
all('a[href="#invitation"]').forEach(link => link.addEventListener('click',e => {
  e.preventDefault();
  if (location.hash !== '#invitation') history.pushState(null,'','#invitation');
  q('#invitation-note').focus({preventScroll:true});
  q('#invitation').scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth',block:'start'});
}));
const launchSignup=q('[data-launch-signup]');
const instantAccessOpen = () => launchSignup?.dataset.instantAccess === 'true' && Date.now() < Date.parse(launchSignup.dataset.accessUntil);
if(launchSignup?.dataset.signupReady==='true')q('#signup-fallback [type=submit]').disabled=false;
async function applyDeliveryVoucher(code) {
  if(!/^LUMA-EARLY-[A-Z2-9]{8}$/.test(code))throw Error('delivery');
  const response=await fetch('/discount/'+encodeURIComponent(code)+'?redirect=/password',{credentials:'same-origin',signal:AbortSignal.timeout(15000)});
  if(!response.ok)throw Error('delivery');
}
function showSignupConfirmation(voucher='') {
  if(voucher){try{sessionStorage.setItem('luma:early-delivery:v1',voucher);}catch{}}
    const confirmation=document.createElement('div');confirmation.className='confirmation';confirmation.id='confirmation';confirmation.tabIndex=-1;confirmation.setAttribute('role','status');
    const eyebrow=document.createElement('p');eyebrow.className='eyebrow';
    const title=document.createElement('h3'),copy=document.createElement('p');
    if(instantAccessOpen()||voucher){
      eyebrow.textContent='YOUR FIRST TASTE';title.textContent="You're in. Take a little look.";
      copy.textContent=launchSignup.dataset.shippingReady==='true'?'Your password is below. Free UK delivery is included on your first luma 2.0 order. No minimum spend.':'Your password is below. Take your first look at the new chocolates.';
      const passwordLabel=document.createElement('label');passwordLabel.htmlFor='signup-access-password';passwordLabel.textContent='Your early-access password';
      const password=document.createElement('input');password.id='signup-access-password';password.type='text';password.readOnly=true;password.value=launchSignup.dataset.accessPassword;password.autocomplete='off';password.spellcheck=false;
      const passwordRow=document.createElement('div');passwordRow.className='signup-password-row';
      const copyButton=document.createElement('button');copyButton.type='button';copyButton.className='signup-copy-password';copyButton.textContent='Copy password';
      const accessStatus=document.createElement('p');accessStatus.className='signup-access-status';accessStatus.setAttribute('aria-live','polite');
      copyButton.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(password.value);copyButton.textContent='Copied';accessStatus.textContent='Password copied.';}catch{password.focus();password.select();accessStatus.textContent='Password selected. You can copy it now.';}});
      passwordRow.append(password,copyButton);
      const enter=document.createElement('button');enter.type='button';enter.className='primary signup-enter-shop';enter.textContent='Enter the shop ↗';
      enter.addEventListener('click',async()=>{
        if(enter.disabled)return;enter.disabled=true;enter.setAttribute('aria-busy','true');enter.textContent='Opening the shop…';
        try{
          const nativePassword=q('#luma-store-password'),nativeInput=q('#store-password');
          if(voucher)await applyDeliveryVoucher(voucher);nativeInput.value=password.value;nativePassword.requestSubmit();
        }catch{accessStatus.textContent="We couldn't open the shop. Please try the button again. Your password is above.";enter.disabled=false;enter.removeAttribute('aria-busy');enter.textContent='Enter the shop ↗';}
      });
      const benefit=document.createElement('p');benefit.className='signup-benefit-note';benefit.textContent='Your first-order delivery benefit stays with you after public opening. Use your signup email at checkout. '+(voucher?'Delivery is applied automatically. There is no code to enter.':'Delivery will be recognised using your signup email.');
      confirmation.append(eyebrow,title,copy,passwordLabel,passwordRow,enter,accessStatus);if(launchSignup.dataset.shippingReady==='true')confirmation.append(benefit);
    }else{
      eyebrow.textContent='A LITTLE LOOK AHEAD';title.textContent="You're on the Luma 2.0 launch list.";copy.textContent="We'll send the shopping link to your inbox when the shop opens. Already subscribed? This registration uses the same email profile.";confirmation.append(eyebrow,title,copy);
    }
    const fallback=q('#signup-fallback');fallback.replaceChildren(confirmation);fallback.hidden=false;q('#luma-delivery-form')?.setAttribute('hidden','');q('#delivery-form-status')?.setAttribute('hidden','');q('#signup').classList.add('is-confirmed');confirmation.focus({preventScroll:true});
}
const deliveryForm=q('#luma-delivery-form'),deliveryStatus=q('#delivery-form-status');
const usesDeliveryForm=Boolean(deliveryForm&&launchSignup.dataset.deliveryFormId&&instantAccessOpen());
let deliverySubmitted=false,deliveryPreparing=false;
if(usesDeliveryForm){
  let deliveryDeadline;
  const unavailable=()=>{
    if(!deliveryStatus||q('#confirmation'))return;
    deliveryStatus.hidden=false;deliveryStatus.setAttribute('role','alert');
    deliveryStatus.textContent="We couldn't prepare your delivery benefit. Please reload and try your email again. Already registered? Your place is saved.";
    const retry=document.createElement('button');retry.type='button';retry.className='signup-copy-password';retry.textContent='Reload registration';retry.addEventListener('click',()=>location.reload());deliveryStatus.append(document.createElement('br'),retry);
  };
  const readiness=setTimeout(()=>{if(!deliveryForm.querySelector('input[type=email]'))unavailable();},15000);
  const inspectDelivery=async()=>{
    const nativeEmail=deliveryForm.querySelector('input[type=email]');if(nativeEmail&&!deliverySubmitted){nativeEmail.placeholder=q('#email')?.placeholder||'you@example.com';clearTimeout(readiness);deliveryStatus.hidden=true;}
    if(!deliverySubmitted||deliveryPreparing||q('#confirmation'))return;
    const code=deliveryForm.textContent.match(/LUMA-EARLY-[A-Z2-9]{8}/)?.[0];
    if(!code)return;
    deliveryPreparing=true;deliveryStatus.hidden=false;deliveryStatus.textContent='Preparing your free UK delivery…';
    try{await applyDeliveryVoucher(code);if(signal.aborted)return;clearTimeout(deliveryDeadline);showSignupConfirmation(code);observer.disconnect();}
    catch{deliveryPreparing=false;unavailable();}
  };
  const observer=new MutationObserver(inspectDelivery);observer.observe(deliveryForm,{childList:true,subtree:true,characterData:true});
  signal.addEventListener('abort',()=>{observer.disconnect();clearTimeout(readiness);clearTimeout(deliveryDeadline);},{once:true});
  window.addEventListener('klaviyoForms',event=>{
    if(event.detail?.formId!==launchSignup.dataset.deliveryFormId||event.detail?.companyId!==launchSignup.dataset.companyId)return;
    if(event.detail.type==='submit'){
      deliverySubmitted=true;deliveryForm.classList.add('is-submitted');deliveryForm.setAttribute('aria-hidden','true');deliveryForm.inert=true;clearTimeout(readiness);
      const submittedEmail=event.detail.metaData?.email;
      if(submittedEmail&&window.klaviyo?.identify)window.klaviyo.identify({email:submittedEmail,luma_2_0_registered:true,luma_2_0_signup_source:'password-page',luma_2_0_consent_version:'consent-v1',luma_2_0_early_access_registered:true,luma_2_0_early_access_registered_at:new Date().toISOString()}).catch(()=>{});
      deliveryDeadline=setTimeout(()=>{if(!q('#confirmation'))unavailable();},15000);inspectDelivery();
    }
  },{signal});
  const guardRegistration=event=>{
    if(event.type==='click'&&!event.target.closest('button.klaviyo-form-button, input[type=submit]'))return;
    if(!instantAccessOpen()){event.preventDefault();event.stopImmediatePropagation();deliveryForm.hidden=true;deliveryStatus.hidden=false;deliveryStatus.textContent='Early-access registration has finished. Visit the shop for the latest.';}
  };
  deliveryForm.addEventListener('click',guardRegistration,true);
  deliveryForm.addEventListener('submit',guardRegistration,true);
  inspectDelivery();
}
q('#signup-fallback').addEventListener('submit',async e => {
  const email = q('#email'), consent = q('#consent');
  if (!email || email.disabled) {e.preventDefault(); return;}
  email.value = email.value.trim();
  const emailError = !email.value ? t('email_required') : !email.validity.valid ? t('email_invalid') : '';
  const consentError = !consent.checked ? t('consent_required') : '';
  fieldError(email,'#email-error',emailError); fieldError(consent,'#consent-error',consentError);
  if (emailError || consentError) {e.preventDefault(); (emailError ? email : consent).focus();return;}
  const launch=q('[data-launch-signup]');if(!launch)return;
  if(launch.dataset.accessPhaseEnabled==='true' && Date.now()>=Date.parse(launch.dataset.accessUntil)){
    e.preventDefault();const ended=document.createElement('p');ended.className='field-error';ended.setAttribute('role','status');ended.textContent='Early-access registration has finished. Visit the shop for the latest.';const link=document.createElement('a');link.href='/';link.textContent=' Visit the shop ↗';ended.append(link);e.currentTarget.replaceChildren(ended);return;
  }

  e.preventDefault();const form=e.currentTarget,button=form.querySelector('[type=submit]');
  if(button.disabled)return;button.disabled=true;button.setAttribute('aria-busy','true');
  let status=q('#launch-signup-status');if(!status){status=document.createElement('p');status.id='launch-signup-status';status.className='field-error';status.setAttribute('role','status');form.append(status);}status.textContent='Joining the launch list…';
  const timeout=new AbortController(),timer=setTimeout(()=>timeout.abort(),15000);
  try{
    const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(launch.dataset.companyId),{method:'POST',headers:{'Content-Type':'application/json',revision:'2025-07-15'},signal:timeout.signal,body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Luma 2.0 password-page signup · consent-v1',profile:{data:{type:'profile',attributes:{email:email.value,properties:{luma_2_0_registered:true,luma_2_0_signup_source:'password-page',luma_2_0_consent_version:'consent-v1',...(instantAccessOpen()?{luma_2_0_early_access_registered:true,luma_2_0_early_access_registered_at:new Date().toISOString()}: {})}}}}},relationships:{list:{data:{type:'list',id:launch.dataset.listId}}}}})});
    if(!response.ok)throw Error('signup');
    showSignupConfirmation();
  }catch{status.setAttribute('role','alert');status.textContent="We couldn't confirm your registration. Please try again in a moment.";button.disabled=false;button.removeAttribute('aria-busy');}
  finally{clearTimeout(timer);}
});
if (q('#email')) q('#signup-fallback').noValidate = true;
q('#confirmation')?.focus({preventScroll:true});
q('#signup-server-error')?.focus({preventScroll:true});
const accessDetails = q('.store-access'), accessPanel = q('.password-panel');
const accessDialog = q('#password-access-dialog'), passwordInput = q('#store-password');
const passwordError = q('#password-error');
let accessOpener, previousOverflow;
accessDetails.open = false;
q('[data-password-slot]').append(accessPanel);
passwordInput.setAttribute('aria-describedby',`password-access-help${passwordError ? ' password-error' : ''}`);
accessPanel.querySelector('button[type="submit"]').textContent = t('early_access_enter');
function openAccess(opener) {
  accessOpener = opener;
  if (!accessDialog.open) {previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; accessDialog.showModal();}
  (passwordError || passwordInput).focus({preventScroll:true});
}
all('[data-password-open]').forEach(link => link.addEventListener('click',e => {e.preventDefault(); openAccess(link);},{signal}));
accessDetails.querySelector('summary').addEventListener('click',e => {e.preventDefault(); openAccess(e.currentTarget);},{signal});
q('.password-dialog-close').addEventListener('click',() => accessDialog.close(),{signal});
accessDialog.addEventListener('click',e => {
  if (e.target !== accessDialog) return;
  const box = accessDialog.getBoundingClientRect();
  if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) accessDialog.close();
},{signal});
accessDialog.addEventListener('close',() => {
  document.body.style.overflow = previousOverflow || '';
  passwordInput.type = 'password';
  q('[data-password-visibility]').setAttribute('aria-pressed','false');
  q('[data-password-visibility]').textContent = t('show_password');
  accessOpener?.focus({preventScroll:true});
},{signal});
q('[data-password-visibility]').addEventListener('click',e => {
  const show = passwordInput.type === 'password';
  passwordInput.type = show ? 'text' : 'password';
  e.currentTarget.setAttribute('aria-pressed',String(show));
  e.currentTarget.textContent = t(show ? 'hide_password' : 'show_password');
},{signal});
if (passwordError) openAccess(q('[data-password-open]') || accessDetails.querySelector('summary'));
q('#reset')?.addEventListener('click',() => {
  q('.choices').scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth',block:'start'});
  q('[data-choice][aria-pressed=true]').focus({preventScroll:true});
});
let privacyOpener;
all('[data-privacy]').forEach(b => b.addEventListener('click',() => {privacyOpener=b; q('#privacy-dialog').showModal();}));
all('.dialog-close').forEach(b => b.addEventListener('click',() => q('#privacy-dialog').close()));
q('#privacy-dialog').addEventListener('close',() => privacyOpener?.focus());
reduced.addEventListener('change',() => {clearTimeout(changeTimer);clearTimeout(revealTimer);select(requested,false);},{signal});
render('dawn');
return () => {if (accessDialog.open) {accessDialog.close(); document.body.style.overflow = previousOverflow || '';} accessDetails.append(accessPanel); version++; companionVersion++; clearTimeout(warmTimer); pendingImages.clear(); controller.abort(); pauseFilm(); sizeObserver.disconnect(); visibilityObserver.disconnect(); clearTimeout(changeTimer); clearTimeout(revealTimer); cancelAnimationFrame(scrollFrame); printAnimation?.cancel();};
}
if (!customElements.get("luma-password")) customElements.define("luma-password",class extends HTMLElement {connectedCallback(){if(!this.cleanup)this.cleanup=initialiseLuma(this);}disconnectedCallback(){this.cleanup?.();this.cleanup=null;}});
